type LightningIconProps = {
  color?: string;
  size?: number | string;
};

export const LightningIcon = ({ color = 'currentColor', size = 16 }: LightningIconProps): JSX.Element => (
  <svg style={{ color }} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.49968 1.33331H5.66264C5.54298 1.33331 5.48316 1.33331 5.43034 1.35153C5.38363 1.36764 5.34109 1.39393 5.30579 1.42851C5.26587 1.4676 5.23912 1.52111 5.18561 1.62813L2.38561 7.22813C2.25782 7.4837 2.19393 7.61149 2.20927 7.71537C2.22268 7.80607 2.27285 7.88725 2.34798 7.9398C2.43403 7.99998 2.5769 7.99998 2.86264 7.99998H6.99968L4.99968 14.6666L13.1284 6.23685C13.4027 5.95245 13.5398 5.81025 13.5478 5.68857C13.5548 5.58295 13.5112 5.4803 13.4303 5.412C13.3371 5.33331 13.1396 5.33331 12.7445 5.33331H7.99968L9.49968 1.33331Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
